import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./SelectBox.css";
const SelectBox = React.forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [defaultSelected, setDefaultSelected] = useState([]);
  useEffect(() => {
    try{
    if(props.defaultSelected && props.defaultSelected.length > 0)
    {
      setDefaultSelected(props.defaultSelected);
      setIsLoading(false);
    }
    else if (
      props.defaultValue &&
      props.defaultValue !== "" &&
      props.defaultValue !== 0 &&
      props.defaultValue !== "0"
    ) {
      if (props.options && props.options.length > 0 && isLoading) {
        props.setValue && props.setValue(props.name, props.defaultSelected);
        setDefaultSelected(props.defaultSelected);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }catch (error){
    console.warn("defaultValue",error);
  }
  finally{
    setIsLoading(false);
  }
  }, [props, isLoading]);

  if (isLoading)
    return (
      <div className="input-group mb-3">
        <input
          disabled
          type="loader"
          className="form-control"
          placeholder="Loading..."
        />
        <span className="input-group-text loading-icon" id="basic-addon1">
          <i className="myloader"></i>
        </span>
      </div>
    );
    const ToggleButton = ({ isOpen, onClick }) => (
      <button
        className="toggle-button"
        onClick={onClick}
        onMouseDown={e => {
          // Prevent input from losing focus.
          e.preventDefault();
        }}>
        {isOpen ? '▲' : '▼'}
      </button>
    );
  return (
    <Typeahead
      /* clearButton */
      {...props}
      defaultSelected={defaultSelected}
      defaultValue={props.defaultValue}
      multiple={props.multiple}
      onSearch={(query) => true}
      isLoading={isLoading}
      id={props.id || "TA-"+Math.random()}
      onChange={props.OnChange}
      options={props.options || []}
      labelKey={props.labelKey}
      ref={ref}
      placeholder= {props.placeholder || "Choose Option"}
    >
    { props.arrowIconHide ? "" : ({ isMenuShown, toggleMenu }) => (
      <ToggleButton isOpen={isMenuShown} onClick={e => toggleMenu()} />
    )}
    </Typeahead>
  );
});
export default SelectBox;
